import { Query } from '../../../_base/actionBus/Query';
import { Slot } from '../../../models/amenities/Slot';

export class SearchDateAvailableSlots extends Query<Slot[]> {
    constructor(public amenityId: number, public date: string) {
        super();
    }
}
